export const registration_intro = {
  title: "Create your account",
  link_login: "Sign in instead",
};
